
export enum AdminRoutesPath {
    default = 'default',
    project = 'project',
    manageProject = 'manageProject',
    approvedOrder = 'approvedOrder',
    newProject = 'newProject',
    projetoFinance = 'projetoFinance',
    launchedProject = 'launchedProject',
    timeTracker = 'timeTracker',
    newCompanies = 'newCompanies',
    order = 'order',
    templateItem = 'templateItem',
    bussinesModel = 'bussinesModel',
    description = 'description',
    midiaOrder = 'midiaOrder',
    entregavelOrder = 'entregavelOrder',
    productOrder = 'productOrder',
    measureUnit = 'measureUnit',
    footNotes = 'footNotes',
    reports = 'reports',
    finance = 'finance',
    accountType = 'accountType',
    contaFinanceira = 'contaFinanceira',
    typeFinance = 'typeFinance',
    // releasesFinance = 'releasesFinance',
    pedidoCompra = 'pedidoCompra',
    contasPagar = 'contasPagar',
    contasReceber = 'contasReceber',
    occurrence = 'occurrence',
    categorias = 'categorias',
    subcategories = 'subcategories',
    paymentForm = 'paymentForm',
    clients = 'clients',
    typeClients = 'typeClients',
    classificationClients = 'classificationClients',
    config = 'config',
    depto = 'depto',
    centroCusto = 'centroCusto',
    verbaDpto = 'verbaDpto',
    newProducts = 'newProducts',
    newUsers = 'newUsers',
    profile = 'profile',
    logoff = 'logoff'
}
